import { ZuruflexSession } from '@zuruflex/api-client';
import { currentLocale } from '../i18n.js';

/**
 * One session for the dashboard, created at module load so the token is in
 * place before React renders anything.
 *
 * `session.client` is the API client: it carries the access token, and
 * exchanges the refresh token by itself when the access token expires
 * mid-session — which, at fifteen minutes, it routinely will.
 */
export const session = new ZuruflexSession({
  realm: 'STAFF',
  baseUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:4001',
  // A function, so switching language takes effect on the next request
  // rather than needing the client rebuilt.
  locale: currentLocale,
});

export const api = session.client;

/** Empty when no client id is configured; the sign-in page hides the button. */
export const googleClientId: string = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';
